module.exports = __webpack_public_path__ + "img/button_green_top.76231cfb.svg";